import "./Banglore_cities.css";
const Noida_cities = ()=>{
    return(
        <div className="main_div">
            <h2 className="city">Popular Localities</h2>
            <p className="city">Andheri East</p>
            <p className="city">Vashi</p>
            <p className="city">Andheri West</p>
            <p className="city">Thane</p>
            <p className="city">Bandra</p>
            <p className="city">Dadar</p>
            <p className="city">Panvel</p>
            <p className="city">Navi Noida</p>
            <p className="city">All of Noida</p>
           
        </div>
    )
}
export {Noida_cities}